import { HTTP_STATUS_CODES } from '@showbie-socrative/socrative-utils';

import { TeacherApplicationContext } from '~shared/context/TeacherApplicationContext';
import { ReportUrls } from '~shared/utils/urlBuilders/ReportsUrlBuilder';
import { ReportOptionState } from '~teacher/components/ExportReports/ReportOption/ReportOptionHookReducer';
import { ActivityReportRequestParams } from '~teacher/models/reports';

import { pollForDownloadReady } from '../../util/ReportDownload';
import localAxios from '../localAxios';
import { FetchStudentRosterResponse } from './reportsResponses';

const reportUrls = new ReportUrls();

const fetchStudentRoster = async (activityInstanceId: number) => {
  const url = reportUrls.fetchStudentRosterUrl(activityInstanceId);
  const response = await localAxios.get(url);
  const { data } = response;
  return data;
};

const emailReportsToTeacher = async (
  requestParams: ActivityReportRequestParams,
  options?: ReportOptionState
) => {
  const url = reportUrls.reportDeliveryUrl(requestParams);

  const response = await localAxios.post<FetchStudentRosterResponse>(url, {
    activity_instance_id: requestParams.activityInstanceId,
    options,
  });
  const { data } = response;
  return data;
};

const emailReportsToStudents = async (payload) => {
  const url = reportUrls.emailStudentsUrl();
  const response = await localAxios.post(url, payload);
  const { data } = response;
  return data;
};

const uploadToDrive = async (
  requestParams: ActivityReportRequestParams,
  options?: ReportOptionState
) => {
  const url = reportUrls.reportDeliveryUrl(requestParams);
  const response = await localAxios.post(url, {
    activity_instance_id: requestParams.activityInstanceId,
    options,
  });

  const { data } = response;
  return data;
};

const downloadReports = async (
  requestParams: ActivityReportRequestParams,
  appContext: TeacherApplicationContext,
  options?: ReportOptionState,
  onPrepareComplete?: (url: string) => void,
  onPollComplete?: (url: string) => void,
  onPollError?: (error: any) => void
) => {
  const url = reportUrls.reportDeliveryUrl(requestParams);
  const response = await localAxios.post<{ url: string }>(url, {
    activity_instance_id: requestParams.activityInstanceId,
    options,
  });

  const { data, status } = response;
  if (data && status === HTTP_STATUS_CODES.HTTP_200_OK) {
    const { url: pollingUrl } = data;
    onPrepareComplete(pollingUrl);
    pollForDownloadReady({
      pollingUrl,
      onPollComplete,
      onPollError,
      appContext,
    });
  }
};

export {
  downloadReports,
  fetchStudentRoster,
  emailReportsToTeacher,
  emailReportsToStudents,
  uploadToDrive,
};
